import api from ".";

export const getDocuments = async () => {
  const token = localStorage.getItem("uniservice_token");
  try {
    const response = await api.get("/api/v1/documents", {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ocorreu um erro ao carregar lista de documentos.", error);
  }
};

export const createDocument = async (formData: FormData) => {
  const token = localStorage.getItem("uniservice_token");
  try {
    const response = await api.post("/api/v1/documents", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Ocorreu um erro ao salvar documento.", error);
  }
};
export const updateDocument = async (documentId: number, data: any) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/documents/${documentId}`;

  try {
    let payload: any;

    if (data instanceof FormData) {
      payload = data;
      if (!payload.has("_method")) {
        payload.append("_method", "PUT");
      }
    } else {
      payload = new FormData();
      if (data.name) payload.append("name", data.name);
      if (data.status) payload.append("status", data.status);
      if (data.expiration_date)
        payload.append("expiration_date", data.expiration_date);

      if (Array.isArray(data.employees)) {
        data.employees.forEach((id: number | string) =>
          payload.append("employees[]", String(id)),
        );
      }

      if (data.pdf_file instanceof File) {
        payload.append("pdf_file", data.pdf_file);
      }
      payload.append("_method", "PUT");
    }

    const response = await api.post(url, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error(
      "Erro ao atualizar documento:",
      error.response?.data || error,
    );
    throw error;
  }
};

export const deleteDocument = async (id: number) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/documents/${id}`;

  try {
    const response = await api.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error("Erro ao excluir documento.", error);
  }
};

export const downloadDocuments = async (hash: string) => {
  const url = `/documents/${hash}`;
  const token = localStorage.getItem("uniservice_token");

  try {
    const response = await api.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/pdf",
      },
    });
    return response;
  } catch (error) {
    console.error("Documento nao encontrado.", error);
  }
};
